import React from "react";
import Header from "../Header";
import HeroSection from "../HeroSection";
import Services from "../Services";
import Logo from "../Logo";
import RecentClients from "../RecentClients";
import TestimonialsCarousel from "../TestimonialsCarousel";
import OurWorks from "../Works";
import About from "../About";
import "../../index.css";
import EagleSection from "../EagleSection";
import FooterWithMenu from "../Footer";
// import "../Work.css"


const Home = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <RecentClients />
      <Logo />
      <OurWorks />
      <About />
      <Services />
      <TestimonialsCarousel />
      <EagleSection/>
      <FooterWithMenu/>
    </>
  );
};

export default Home;
